import React from "react";
import Food from "./Food/Food";
import Drink from "./Drink/Drink";
import Team from "./Team/Team";
export default function About() {
  return (
    <div>
      <Food />
      <Drink />
      <Team />
    </div>
  );
}
